



























import SurfaceBuilder from 'vuecomponents/surface_builder.vue'
import ProcessedImage from 'vuecomponents/processed_image.vue'
import { link } from 'bits/autolinker'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { IntlMixin } from 'vuemixins/intl_mixin'

@Component({
  components: {
    SurfaceBuilder,
    ProcessedImage,
  },
})
export default class SurfaceTitle extends Mixins(IntlMixin) {
  @Getter title!: string
  @Getter description!: string
  @Getter portrait!: string
  @Getter canIAdminister!: boolean

  get xBuilder(): boolean {
    return !this.$store.state.isEmbedded
  }

  get hyperlinkedDescription(): string {
    return link(this.description)
  }

  @Watch('title')
  onTitleChanged(): void {
    this.$emit('title-changed')
  }

  @Watch('description')
  onDescriptionChanged(): void {
    this.$emit('description-changed')
  }

  tryModify(): void {
    if (this.canIAdminister) {
      this.$store.dispatch('settings/showSettingsPanel')
    }
  }
}
